import { ComponentType } from 'react';

import { IconProps } from '@/components/icons/ChevronDownIcon';
import { CoinsHandDuotoneIcon } from '@/components/icons/CoinsHandDuotoneIcon';
import { HorizontalBarChart02DuotoneIcon } from '@/components/icons/HorizontalBarChart02DuotoneIcon';
import { PieChart03DuotoneIcon } from '@/components/icons/PieChart03DuotoneIcon';

export interface AnalysisTypeDefinition {
  heading: string;
  body: string;
}

export interface AnalysisTypeDefinitionWithIcon extends AnalysisTypeDefinition {
  icon: ComponentType<IconProps>;
}

export const GIFT_ANALYSIS_V2: AnalysisTypeDefinitionWithIcon = {
  heading: 'Gift',
  body: 'Model the impact of gifts, such as funding a SLAT, FLP, DAF, or making annual exclusion gifts',
  icon: CoinsHandDuotoneIcon,
};

export const GRAT_ANALYSIS_V2: AnalysisTypeDefinitionWithIcon = {
  heading: 'GRAT',
  body: 'Model the impact of transferring a high-growth asset to a Grantor Retained Annuity Trust',
  icon: PieChart03DuotoneIcon,
};

export const CRT_ANALYSIS_V2: AnalysisTypeDefinitionWithIcon = {
  heading: 'CRT',
  body: 'Model the potential charitable and income benefits of funding a Charitable Remainder Trust',
  icon: HorizontalBarChart02DuotoneIcon,
};

export const CLT_ANALYSIS_V2: AnalysisTypeDefinitionWithIcon = {
  heading: 'CLT',
  body: 'Model the potential charitable and legacy benefits of funding a Charitable Lead Trust',
  icon: HorizontalBarChart02DuotoneIcon,
};
